import styled from "styled-components";
export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      /* height: calc(-100px + 100vh); */
    }
  }
`;
export const ContentSection = styled.div`
  @media screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text-container {
      max-width: 700px;
      margin-left: 0px;
      text-align: left;
    }
  }

  padding: 20px 16px;
  .title {
    font-weight: bold;
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 25px;
  }
  .description {
    color: #818d88;
  }

  .charts {
    margin-top: 20px;
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr;

    .box-title {
      color: #142c1f;
      font-weight: 500;
      text-align: center;
    }

    .chart-box {
      border: 2px solid rgb(226, 228, 233);
      padding: 20px;
      border-radius: 20px;
      box-shadow: rgba(214, 214, 214, 0.16) 0px 13px 20px;
    }

    .chart {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 200px;
    }

    .bullet {
      width: 20px;
      height: 20px;
      background: black;
      border-radius: 50%;
    }

    .protein {
      background: #c74343;
    }
    .carbs {
      background: #2ecf96;
    }
    .fats {
      background: #ffc403;
    }

    .details {
      display: flex;
      flex-direction: column;
      gap: 5px;

      > * {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        min-width: 200px;
        margin: 0 auto;

        span {
          font-weight: 500;
          font-size: 14px;
          min-width: 150px;
        }
      }
    }
  }
  @media (min-width: 768px) {
    padding: 24px 20px;
  }
`;
export const DesktopView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; // Left align content
  justify-content: center;
  width: 100%;
`;

export const DesktopContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 700px;
  justify-content: center;
  align-items: center;

  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 25px;
    width: 100%;
  }
`;

export const DesktopTextContent = styled.div`
  text-align: left;
`;

export const Title = styled.h3`
  color: #142c1f;
  margin: 0 0 12px;
  font-size: 16px;
`;
export const ChartTitle = styled.h3`
  color: #142c1f;
  margin: 0 0 12px;
  font-size: 16px;
  margin-top: 20px;
`;
export const RezeptTitle = styled.h3`
  color: #142c1f;
  margin: 0 0 16px;
  font-size: 16px;
`;
export const Description = styled.p`
  color: #818d88;
  margin: 0 0 16px;
`;

export const ChartWrapper = styled.div`
  border: 1px solid #e2e4e9;
`;
export const SliderWrapper = styled.div`
  flex: 1;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;
export const PieChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 20px 60px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  border: 2px solid #e2e4e9;

  .details-center {
    display: flex;
    align-items: center;
    margin: 5px 0;

    .bullet {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-right: 10px;
    }

    h3 {
      display: flex;
      gap: 8px;
      margin: 0;

      span {
        font-size: 14px;
        color: #666;

        &:first-child {
          font-weight: 600;
          color: #333;
        }
      }
    }
  }

  /* Make sure the pie chart has a defined height */
  .content-container {
    height: 250px;
    width: 100%;
  }
`;
